import { dateFormat } from "./formData";
let setWatermark = (name, phone, type) => {
  let time = dateFormat(new Date());
  // let time = localStorage.getItem("times") || dateFormat(new Date());
  localStorage.setItem("times", time);
  let id =
    Math.random() * 10000 +
    "-" +
    Math.random() * 10000 +
    "/" +
    Math.random() * 10000;
  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id));
  }

  let can = document.createElement("canvas");
  can.width = 600;
  can.height = 300;

  let cans = can.getContext("2d");
  cans.rotate((-20 * Math.PI) / 180);
  cans.font = "15px Vedana";
  cans.fillStyle = "rgba(0, 0, 0, .1)";
  cans.textAlign = "center";
  cans.textBaseline = "middle";//原来设定的是center
  const lf = type == 1 ? 30 : 340;
  const tp = type == 1 ? 260 : 180;
  cans.fillText(name, lf, tp);
  cans.fillText(phone, lf, tp - 20);
  cans.fillText(time, lf, tp + 20);
  return can.toDataURL("image/png");
};
export default setWatermark;
